<template>
  <SideMenuLayout title="Facturation électronique" :items="items">
    <slot/>
  </SideMenuLayout>
</template>

<script>
import SideMenuLayout from "@/components/SideMenuLayout.vue";

export default {
  name: "InvoiceTransmissionHeader",
  components: {SideMenuLayout},
  data() {
    return {
      isInvoiceTransmissionLinked: localStorage.isInvoiceTransmissionLinked === "true"
    };
  },
  computed: {
    items() {
      const items = [{to: '/facture-x-dashboard', label: 'Dashboard', icon: 'grid'}];
      if (this.isInvoiceTransmissionLinked) {
        items.push({to: '/facture-x-clients', label: 'Clients', icon: 'users'});
        items.push({to: '/facture-x-outgoing-invoices', label: 'Factures sortantes', icon: 'outgoing'});
        items.push({to: '/facture-x-incoming-invoices', label: 'Factures entrantes', icon: 'incoming'});
        items.push({to: '/facture-x-e-reporting', label: 'E-reporting', icon: 'list'});
      }
      return items;
    }
  },
  mounted() {
    window.addEventListener("invoice-transmission-link-changed", this.updateLinkStatus);
  },
  beforeUnmount() {
    window.removeEventListener("invoice-transmission-link-changed", this.updateLinkStatus);
  },
  methods: {
    updateLinkStatus() {
      this.isInvoiceTransmissionLinked = localStorage.isInvoiceTransmissionLinked === "true";
    }
  }
};
</script>
